/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
import {
  TextField as MuiTextField,
  Button,
  Grid,
  IconButton,
  TextField,
  InputAdornment,
} from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { details, late, makeReport } from '../HomeActions'
import BaseFilter from '../../../components/hooks/BaseFilter'
import filterStylesComponents from '../../../assets/filterComponentsStyles'
import {
  mdiFilterMultiple,
  mdiMagnify,
  mdiMagnifyExpand,
  mdiMicrosoftExcel,
  mdiTable,
} from '@mdi/js'
import colors from '../../../assets/colors'
import Icon from '@mdi/react'
import BaseFilterModal from '../../../components/hooks/BaseFilterModal'
import { KeyboardDatePicker } from '@material-ui/pickers'
import SelectField from '../../components/SelectField'

export const DetailsFilter = ({ detailsId, toggleColumnsModal = () => {} }) => {
  const dispatch = useDispatch()
  const styles = filterStylesComponents()
  const serviceTypes = useSelector(state => state.dashboard.service_types)

  const [openFilter, setOpenFilter] = useState(false)
  const [filters, setFilters] = useState({
    collected_date: null,
    name: '',
    service_type: '',
  })

  const handleExportExcel = e => {
    e.preventDefault()
    dispatch(makeReport(detailsId, filters))
  }

  const handleChange = e => {
    e.preventDefault()
    const { name, value } = e.target
    setFilters({
      ...filters,
      [name]: value,
    })
  }

  const handleOpenFilter = () => {
    setOpenFilter(!openFilter)
  }

  const handleChangeServiceType = (
    serviceType = { id: '', name: '' },
    dispatch = false
  ) => {
    const data = {
      ...filters,
      service_type: serviceType || null,
      service_type_id: serviceType?.id || '',
    }
    setFilters(data)
    if (dispatch) dispatch(details(detailsId, data))
  }

  const handleSubmit = e => {
    e.preventDefault()
    dispatch(details(detailsId, filters))
  }

  return (
    <BaseFilter>
      <Grid item xs="12">
        <Grid container spacing="2" justifyContent="space-between">
          <Grid item xs={6}>
            <form style={{ width: '100%' }} onSubmit={handleSubmit}>
              <Grid container spacing={2} alignItems='center'>
                <Grid item xs={12} md={5}>
                  <TextField
                    label="Filtre por cliente"
                    name="name"
                    value={filters?.name}
                    onChange={handleChange}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton type="submit">
                            <Icon
                              path={mdiMagnifyExpand}
                              size={1}
                              color={colors.graylight}
                            />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} md={5}>
                  <SelectField
                    style={{ color: 'black', marginTop: '0px' }}
                    options={serviceTypes}
                    name="service_type_id"
                    setForm={handleChangeServiceType}
                    data={filters?.service_type || null}
                    uniqueState
                    label="Filtre por serviço"
                  />
                </Grid>

                <Grid item xs={2}>
                  <IconButton className={styles.btnAdd} onClick={handleSubmit}>
                    <Icon path={mdiMagnify} size={1} />
                    Pesquisar
                  </IconButton>
                </Grid>
              </Grid>
            </form>
          </Grid>

          <Grid item className={styles.areaButtons}>
            <IconButton
              className={styles.btnMoreFilters}
              onClick={toggleColumnsModal}
            >
              <Icon path={mdiTable} size={1} color={colors.secondary} />
              Colunas da tabela
            </IconButton>

            <IconButton
              className={styles.btnMoreFilters}
              onClick={handleOpenFilter}
            >
              <Icon
                path={mdiFilterMultiple}
                size={1}
                color={colors.secondary}
              />
              Filtros
            </IconButton>

            <IconButton className={styles.btnAdd} onClick={handleExportExcel}>
              <Icon path={mdiMicrosoftExcel} size={1} />
              Download
            </IconButton>
          </Grid>
        </Grid>
      </Grid>

      <BaseFilterModal
        open={openFilter}
        handleOpen={handleOpenFilter}
        title={'Filtros'}
        hiddenHelpButton
      >
        <Grid item xs="12" style={{ width: '230px' }}>
          <form style={{ width: '100%' }} onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="Filtre por cliente"
                  name="name"
                  value={filters?.name}
                  onChange={handleChange}
                  fullWidth
                />
              </Grid>

              {!detailsId?.includes(20, 30) && (
                <Grid item xs={12}>
                  <KeyboardDatePicker
                    clearable
                    value={filters?.collected_date}
                    label="Data de coleta"
                    fullWidth
                    clearLabel="Limpar"
                    invalidDateMessage="Data inválida"
                    autoOk
                    inputVariant="standard"
                    onChange={date =>
                      setFilters({
                        ...filters,
                        collected_date: date,
                      })
                    }
                    format="dd/MM/yyyy"
                  />
                </Grid>
              )}

              <Grid item xs={12}>
                <SelectField
                  style={{ color: 'black', marginTop: '0px' }}
                  options={serviceTypes}
                  name="service_type_id"
                  setForm={handleChangeServiceType}
                  data={filters?.service_type || null}
                  uniqueState
                  label="Filtre por serviço"
                />
              </Grid>

              <Grid item xs={12}>
                <Grid container alignItems="center" justifyContent="center">
                  <Grid item>
                    <Button
                      type="submit"
                      color={colors.primary}
                      variant="contained"
                      className={styles.btnAdd}
                      onClick={handleOpenFilter}
                    >
                      <SearchIcon />
                      {` Pesquisar`}
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </BaseFilterModal>
    </BaseFilter>
  )
}
